import Classes from 'classnames';

import React from 'react';

export default function SystemFieldProjectViewInImport(props) {

    const project = gd.session.projects.get(props.value);
    const iconClass = gd.const.project.icon[project.projectIcon];

    return (
        <div className="ui5-chip s22 gray">
            <div className={Classes("gd-project-type-icon icon", iconClass)}></div>
            <div className="label">{project.name}</div>
        </div>
    );
}